import React from "react";
import RecipeForm from "../components/Recipe/RecipeForm";

const AddRecipePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-orange-50 pt-24 pb-20 px-4 flex justify-center">
      <RecipeForm />
    </div>
  );
};

export default AddRecipePage;
